export const insuranceEn = {
  insurance: {
    title: "Insurance",
    subtitle: "Manage your crop insurance policies",
    activePolicies: "Active Policies",
    claims: "Claims",
    coverage: "Coverage",
    premium: "Premium",
    startDate: "Start Date",
    endDate: "End Date",
    status: "Status",
    fileClaim: "File Claim",
    viewPolicy: "View Policy",
    renewPolicy: "Renew Policy",
    noPolicies: "No active policies",
    getQuote: "Get a Quote"
  },
  insurancePage: {
    title: "Smart Agricultural Insurance",
    subtitle: "Protect your vineyard and olive grove investments with AI-powered, satellite-monitored insurance that pays out automatically when crops are at risk.",
    howItWorks: "How Our Insurance Works",
    defineParcels: "Define Your Parcels",
    defineParcelsDesc: "Map your vineyard or olive grove boundaries with precise GPS coordinates. Our system analyzes your crop type, location, and historical risks.",
    continuousMonitoring: "Continuous Monitoring",
    continuousMonitoringDesc: "Satellite imagery tracks NDVI, soil moisture, and weather patterns. Our AI identifies stress patterns before visible damage occurs.",
    automaticPayouts: "Automatic Payouts",
    automaticPayoutsDesc: "When satellite data confirms crop stress or damage, claims are processed automatically — no paperwork, no delays.",
    automaticPayoutsDescAlt: "When satellite data confirms crop damage beyond thresholds, smart contracts trigger instant payouts to your wallet—no paperwork required.",
    whatWeCover: "What We Cover",
    vineyardInsurance: "Vineyard Insurance",
    oliveGroveInsurance: "Olive Grove Insurance",
    droughtStress: "Drought Stress",
    frostDamage: "Frost Damage",
    hailDamage: "Hail Damage",
    diseaseDetection: "Disease Detection",
    waterStress: "Water Stress",
    heatStress: "Heat Stress",
    windDamage: "Wind Damage",
    pestDetection: "Pest Detection",
    coverageLevel: "Coverage Level",
    upToCoverage: "Up to {{percent}}% of production value",
    euRiskStandards: "EU Risk Assessment Standards",
    euRiskClassifications: "European Insurance Risk Classifications",
    lowRisk: "Low Risk",
    mediumRisk: "Medium Risk",
    highRisk: "High Risk",
    readyToProtect: "Ready to Protect Your Crops?",
    readyToProtectDesc: "Join thousands of farmers who trust Sentinel Crop to protect their agricultural investments with EU-compliant blockchain technology.",
    getStartedToday: "Get Started Today"
  }
};
